import { Component, Input } from '@angular/core';
import { IStringWithLabel } from 'libraries/pipes/configurable-table/compute-value.pipe';

@Component({
    selector: 'string-with-label',
    template: `
        <ng-container>
            <span>{{ stringWithLabel?.label }}</span> <span class="value" [innerHTML]="stringWithLabel?.value"></span>
        </ng-container>
    `,
    styles: [`
        .value {
            font-weight: bolder;
        }
    `]
})
export class StringWithLabelComponent {
    @Input()
    public stringWithLabel: IStringWithLabel;
}
